<template>
  <div class="flex items-center sm:justify-between">
    <label class="sm:hidden mr-4 inline-block font-medium whitespace-no-wrap"
      >Holiday type</label
    >
    <div
      :class="{ 'is-selected': searchType === 'resort' }"
      class="wrap-type-btn rounded-lg sm:w-1/2 mr-2"
    >
      <div
        @click="$emit('handle-select-type', 'resort')"
        class="type-item rounded w-fit cursor-pointer sm:text-center"
      >
        Resorts
      </div>
    </div>
    <div
      :class="{ 'is-selected': searchType === 'liveaboard' }"
      class="wrap-type-btn rounded-lg sm:w-1/2"
    >
      <div
        @click="$emit('handle-select-type', 'liveaboard')"
        class="type-item rounded w-fit cursor-pointer sm:text-center"
      >
        Liveaboards
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchType: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.wrap-type-btn {
  padding: 3px;
  border: 2px solid transparent;
  transition: 0.3s;
}

.type-item {
  padding: 11px 16px;
  border: 1px solid #afafaf;
}

.is-selected {
  border: 4px solid var(--secondary);
}
</style>
